import React from 'react';
import { PreviousSearchesDesktop } from './PreviousSearchesDesktop';
import { Config, LocationUtils } from '../../utils';

export function PreviousSearchesSourceDesktop(options) {
    return {
        render: ({ onClickItemSilent, displayedWord = '' } = {}) => {
            const { maxPreviousSearches, activeProduct } = options;
            const show = !LocationUtils.isKeywordLongEnoughAccordingWithLanguage(
                displayedWord,
                Config.get('autocompleteOptions'),
                activeProduct,
            );
            return (
                <PreviousSearchesDesktop
                    key="previous-searches"
                    maxLength={maxPreviousSearches}
                    onClickItem={onClickItemSilent}
                    show={show}
                />
            );
        },
    };
}
